module.exports = __webpack_public_path__ + "static/media/pessoa.b1f0145b.png";